
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class DesignRequestBOMGrid extends Serenity.EntityGrid<DesignRequestBOMRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.DesignRequestBOM'; }
        protected getDialogType() { return DesignRequestBOMDialog; }
        protected getIdProperty() { return DesignRequestBOMRow.idProperty; }
        protected getInsertPermission() { return DesignRequestBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return DesignRequestBOMRow.localTextPrefix; }
        protected getService() { return DesignRequestBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}